import React from 'react';
import SVGInline from 'react-svg-inline';
import injectSheet from 'react-jss';

const PaymentSuccessModal = (props) => {
    const {onClose, classes, pendingCount} = props;

    const getSucessMessage = () =>{
        if (pendingCount > 0){
            return (
                <div>
                    You have more pending invoice(s). Please pay all unpaid
                    <br/>
                    invoice(s) to reactivate your account.
                    <br/>
                    For any queries please contact support@hiverhq.com
                </div>
            )
        }else{
            return (
                <div>
                    You can now continue using Hiver. For any queries please contact
                    <br/>
                    support@hiverhq.com
                </div>
            )
        }
    }

    return (
        <div className={classes.root}>
            <SVGInline svg={require("../../images/modal-close.svg")}
                width='10'
                onClick={onClose}
                className = {classes.closeIcon}
            />
            <SVGInline svg={require("../../images/success.svg")}
                width='60'
                className={classes.successIcon}
            />
            <div className={classes.bodyHeader}>
                Transaction Successful
            </div>
            <div className={classes.bodyText}> 
               {getSucessMessage()}
            </div>
        </div>
    ) 
}
const styles = {
    root:{
        padding: '42px 0 20px 0'
    },

    closeIcon: {
        marginBottom: "15px",
        cursor: "pointer",
        margin : "-44px -26px 0 15px",
        float: 'right',
        '&:hover':{
            opacity: '0.7'
        }
    },
    successIcon:{
        marginBottom: "15px",
        cursor: "default"
    },
    bodyHeader:{
        fontFamily: '"Open Sans", sans-serif',
        fontSize: '20px',
        fontWeight: '300',
        color: '#242424',
        marginBottom: '5px'
    },
    bodyText:{
        opacity: '0.52',
        fontFamily: '"Open Sans", sans-serif',
        fontSize: '13px',
        lineHeight: '23px',
        textAlign: 'center',
        color: '#242424'
    }

}

export default injectSheet(styles)(PaymentSuccessModal);